import { api } from "../../../api/apiSlice";

// Vehicle Master (handoff §20.1) - this session's scope is the master
// roster only, not Maintenance Requests (§20.3+, a separate not-yet-built
// screen). vehicleId is globally unique across every branch (unlike
// custId/empId/productCode's branch-local collisions), so - like Employee -
// no {branchId} composite key is needed in any single-vehicle route.
//
// Verified live against the deployed API before wiring: PUT silently
// defaults `isActive` to false when the field is omitted from the body (it
// is NOT preserved from the existing record) - every update must always
// send the vehicle's current isActive value explicitly, never omit it.
export const vehiclesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getVehicles: builder.query({
      query: (params) => ({ url: "/vehicles", params }),
      providesTags: (result) =>
        result
          ? [
              ...result.map((v) => ({ type: "Vehicles", id: v.vehicleId })),
              { type: "Vehicles", id: "LIST" },
            ]
          : [{ type: "Vehicles", id: "LIST" }],
    }),
    getVehicle: builder.query({
      query: (vehicleId) => ({ url: `/vehicles/${vehicleId}` }),
      providesTags: (result, error, vehicleId) => [{ type: "Vehicles", id: vehicleId }],
    }),
    createVehicle: builder.mutation({
      query: (body) => ({ url: "/vehicles", method: "POST", data: body }),
      invalidatesTags: [{ type: "Vehicles", id: "LIST" }],
    }),
    updateVehicle: builder.mutation({
      query: ({ vehicleId, ...body }) => ({
        url: `/vehicles/${vehicleId}`,
        method: "PUT",
        data: body,
      }),
      invalidatesTags: (result, error, { vehicleId }) => [
        { type: "Vehicles", id: vehicleId },
        { type: "Vehicles", id: "LIST" },
      ],
    }),
    // Maintenance Requests - read-only here, only what Stock Management's
    // "Pending Vehicle Requests" LPO picker needs (an APPROVED request's
    // Spares Needed line items). Full request create/approve/reject/
    // attachment management is a separate, not-yet-built screen - out of
    // scope for this pair of endpoints.
    listMaintenanceRequests: builder.query({
      query: (params) => ({ url: "/vehicles/requests", params }),
      providesTags: [{ type: "VehicleRequests", id: "LIST" }],
    }),
    getMaintenanceRequest: builder.query({
      query: (recordGuid) => ({ url: `/vehicles/requests/${recordGuid}` }),
      providesTags: (result, error, recordGuid) => [{ type: "VehicleRequests", id: recordGuid }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetVehiclesQuery,
  useGetVehicleQuery,
  useCreateVehicleMutation,
  useUpdateVehicleMutation,
  useListMaintenanceRequestsQuery,
  useGetMaintenanceRequestQuery,
} = vehiclesApi;
